let isBackNavigation = false;

window.addEventListener('beforeunload', () => {
  const currentUrl = window.location.href;
  sessionStorage.setItem(`scrollPosition_${currentUrl}`, window.scrollY);
});

window.addEventListener('DOMContentLoaded', () => {
  const navEntries = performance.getEntriesByType('navigation');
  if (navEntries.length > 0) {
    const navEntry = navEntries[0];
    isBackNavigation = navEntry.type === 'back_forward';
  }

  if (isBackNavigation) {
    const currentUrl = window.location.href;
    const savedScrollPosition = sessionStorage.getItem(
      `scrollPosition_${currentUrl}`
    );

    if (savedScrollPosition !== null) {
      const scrollPosition = parseInt(savedScrollPosition);
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
      sessionStorage.removeItem(`scrollPosition_${currentUrl}`);
    }
  }
});
